"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var Icon = function Icon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9 2h-11c-1.1 0-2 .9-2 2v11h-.6C3.4 15 2 16.7 2 18.5S3.3 22 5.3 22h9.4c1.9 0 3.3-1.5 3.3-3.3V8.5h3c.6 0 1-.4 1-1V5.3C21.9 3.4 20.7 2 18.9 2zm-15 16.5c0-.8.7-1.5 1.3-1.5h6.4c-.2.5-.3 1-.3 1.5s.1 1 .3 1.5H5.3c-.7 0-1.4-.7-1.4-1.5zM14.7 20c-.6 0-1.2-.6-1.2-1.5 0-.5.1-.9.3-1.1.2-.2.4-.4.7-.4.6 0 1-.4 1-1s-.4-1-1-1H7.9V4h8.2c-.1.3-.2.6-.2 1v13.7c0 .7-.5 1.3-1.2 1.3zm3.2-15c0-.5.5-1 1-1 .4 0 1 .3 1 1.3v1.2h-2V5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.3 12.9c.4.2.8.2 1.2 0 .6-.2 1.3-.6 1.8-1.4.4-.8.6-1.8.6-3.2 0-.8-.6-1.2-1.2-1.3-.4 0-.8-.2-1.2-.4-.3-.2-.8-.2-1.1 0-.5.2-.9.4-1.3.4-.6 0-1.2.5-1.2 1.3m0 0c0 1.4.2 2.4.6 3.2.5.8 1.2 1.2 1.8 1.4m.6-1.9c-.4-.2-.5-.3-.6-.5-.1-.2-.3-.7-.3-1.6.4-.1.7-.2 1-.3.3.1.6.3 1 .3-.1.9-.2 1.4-.3 1.6-.3.2-.4.3-.8.5z"
  }));
};
Icon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#RulesetAsset',
    assetType: 'Ruleset'
  },
  owner: {
    gusTeam: 'MS Mycroft',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in1CYAQ/view'
  },
  name: 'Ruleset',
  pluralName: 'Rulesets',
  visibility: 'public',
  featureFlag: 'governance-enabled',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['ruleset']
    }],
    files: [{
      id: 'ruleset',
      classifier: 'ruleset',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }, {
      id: 'single-ruleset',
      classifier: 'ruleset',
      mainFileLocationProperty: 'mainFile',
      packaging: 'yaml'
    }, {
      id: 'light-ruleset',
      classifier: 'light-ruleset',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip',
      usedAsDependency: true
    }, {
      id: 'fat-ruleset',
      classifier: 'fat-ruleset',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['ruleset'],
      requiredProperties: ['mainFile']
    }, {
      files: ['single-ruleset'],
      requiredProperties: ['mainFile']
    }],
    extensionPoints: [{
      name: 'filesGenerator',
      config: {
        outputFileIds: ['light-ruleset', 'fat-ruleset']
      }
    }, {
      name: 'validation'
    }],
    ootbSteps: [{
      name: 'angModelExtraction'
    }]
  },
  portal: {
    icon: Icon,
    color: '#17bc65',
    // futureGreen3
    files: [{
      fileId: 'ruleset',
      label: 'Ruleset'
    }]
  },
  keywords: ['ruleset', 'rule']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map